import React, { useState, useEffect } from "react";
import { Search, Menu, LogIn } from "lucide-react";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AnimatedLoginForm from "../LoginFile/Login";
import mou1Pdf from "../../assets/MouPdf/Mou1.pdf";
import mou2Pdf from "../../assets/MouPdf/Mou2.pdf";
import mou3Pdf from "../../assets/MouPdf/Mou3.pdf";

const contactInfo = {
  address: "Government Women's Polytechnic College, Sehore, Madhya Pradesh",
  phone: ["07562-292337"],
  email: "prinwpoly.seh@mp.gov.in",
};

const navItems = [
  {
    title: "Home",
    link: "/",
    subItems: [
      { title: "College", link: "/home/college" },
      { title: "Principal", link: "/home/principal" },
      { title: "Vision", link: "/home/vision" },
      { title: "Mission", link: "/home/mission" },
      { title: "Gallery", link: "/gallery/photos" },
    ],
  },
  {
    title: "Department",
    // link: "/department",
    subItems: [
      // { title: "Faculties", link: "/department/faculties" },
      { title: "Computer Science", link: "/department/cse" },
      { title: "Modern Office Management", link: "/department/mom" },
    ],
  },
  {
    title: "Academics",
    // link: "/academics",
    subItems: [
      {
        title: "Admission",
        link: "/admission/procedure",
      },
      // { title: "Acadmic Calender", link: "/academics/acadcalender" },
      {
        title: "Acadmic Calender",
        link: "https://www.rgpvdiploma.in/Academics/Acadmic_calander.aspx",
      },
      { title: "Scheme/Syllabus", link: "academics/scheme-syllabus" },
      // { title: "Scholarships", link: "/academics/scholarships" },
      // { title: " Specialschemes", link: "/academics/specialschemes" },
      { title: " RgpvOrdinace", link: "/academics/rgpv-ordinace" },
      { title: "RgpvAct", link: "/academics/rgpv-act" },

      {
        title: "TimeTable",
        link: "https://www.rgpv.ac.in/uni/frm_viewtt.aspx",
      },
      {
        title: "Result",
        link: "https://www.rgpvdiploma.in/Exam/DiplomaIIIYrResult.aspx",
      },
      { title: "Paper Management", link: "/academics/questionpapermanagement" },
      { title: "VideoLecture", link: "/academics/videolecture" },
      { title: "NoteSection", link: "/academics/notesection" },
    ],
  },
  // {
  //   title: "Admission",
  //   // link: "/admission",
  //   subItems: [
  //     { title: "Admission Procedure", link: "/admission/procedure" },
  //     { title: "Admission Form", link: "/admission/form" }
  //   ],
  // },
  {
    title: "Facilities/Activities",
    // link: "/facilities",
    subItems: [
      { title: "Campus", link: "/facilities/campus" },
      { title: "Library", link: "/facilities/library" },
      { title: "Hostel", link: "/facilities/hostel" },
      { title: "Sports", link: "/facilities/sports" },
      {
        title: "NSS",
        link: "/activities/nss",
      },
      { title: "Women Empowerment", link: "/activities/womenempowerment" },
      { title: "Events", link: "/activities/events" },
      { title: "DCIM Club", link: "/activities/dcimclub" },
    ],
  },
  // {
  //   title: "Activities",
  //   // link: "/activities",
  //   subItems: [
  //     { title: "NSS", link: "/activities/nss" },
  //     { title: "Women Empowerment", link: "/activities/womenempowerment" },
  //     { title: "Events", link: "/activities/events" },
  //     { title: "DCIM Club", link: "/activities/dcimclub" },
  //   ],
  // },
  {
    title: "Training & Placement",
    // link: "/training-and-placement",
    subItems: [
      {
        title: "Career Development Cell",
        link: "/trainingplacement/careerdevelopment",
      },
      {
        title: "Placement Policies",
        link: "/trainingplacement/placementpolicies",
      },
      {
        title: "Guidelines for Students",
        link: "/trainingplacement/guidelines",
      },
      { title: "Career Opportunity", link: "/trainingplacement/recruiters" },
      {
        title: "Collaborations",
        // link: "/trainingplacement/collaborations",
        subItems: [
          { title: "MOU with SGBS Foundation", link: "/MouPdf/Mou1.pdf", isPdf: true },
          { title: "MOU with Zensoft Technologies", link: "/MouPdf/Mou2.pdf", isPdf: true },
          { title: "MOU with SEL Manufacturing", link: "/MouPdf/Mou3.pdf", isPdf: true },
          { title: "MOU with ALFA Proteins(P) LTD", link: "/MouPdf/Mou4.pdf", isPdf: true },
        ],
      },
      {
        title: "Online Link - Youth4work ( Get Jobs and Internships )",
        link: "https://www.youth4work.com/onlinetalenttest",
      },
      {
        title: "Assessment Test Registration",
        link: "https://hiremee.co.in/pooled-campus-registration",
      },
      {
        title: "Our Student Projects",
        link: "/projects",
      },
      {
        title: "Higher Education",
        link: "/higherstudy",
      },
    ],
  },
  {
    title: "Downloads",
    // link: "/downloads",
    subItems: [
      { title: "Student Zone", link: "/downloads/studentzone" },
      // { title: "Admission Form", link: "/downloads/admission-form" }
    ],
  },

  {
    title: "Grievance Cell",
    // link: "/grievancecell",
    subItems: [
      { title: "About", link: "/grievancecell/about" },
      { title: "Grievance/Committee", link: "/grievancecell/committiee" },
    ],
  },
  {
    title: "Feedback",
    // link: "/feedback",
    subItems: [
      { title: "Students", link: "/feedback/students" },
      { title: "Parents", link: "/feedback/parents" },
      { title: "Employer", link: "/feedback/employer" },
      { title: "Alumni", link: "/feedback/alumni" },
    ],
  },
  {
    title: "Contact Us",
    link: "/contactus",
  },
  {
    title: "Tender",
    link: "/tender",
  },
  {
    title: "Apply for Diploma",
    //Payment
    link: "/payment",
  },
  // {
  //   title: "Recruitment",
  //   link: "/recruitment",
  // },
  // {
  //   title: "Projects",
  //   link: "/projects",
  // },
  // {
  //   title: "Higher Education",
  //   link: "/higherstudy",
  // },
  {
    title: "Other",
    subItems: [
      { title: "EOAReports", link: "/other/eoareports" },
      // {
      //   title: "TransferCertificate Application",
      //   link: "/other/transfercertificate",
      // },
    ],
  },
  // {
  //   title: "Login",
  //   link: "/login",
  // },
];

export default function Component() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMobileSubMenu, setActiveMobileSubMenu] = useState(null);
  const [activeMobileNestedSubMenu, setActiveMobileNestedSubMenu] =
    useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [hideTimeout, setHideTimeout] = useState(null);
  const [collaborations, setCollaborations] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchCollaborations = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/v1/mouList/all`);
        setCollaborations(response.data.data);
      } catch (error) {
        console.error("Error fetching collaborations:", error);
      }
    };

    fetchCollaborations();
  }, []);

  // Function to handle mouse enter
  const handleMouseEnter = (title) => {
    // Clear any existing timeout
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      setHideTimeout(null);
    }
    setActiveSubMenu(title); // Show the submenu
  };

  // Function to handle mouse leave
  const handleMouseLeave = () => {
    // Set a timeout to hide submenu after 60 seconds
    const timeout = setTimeout(() => {
      setActiveSubMenu(null);
    }, 500); // half second
    setHideTimeout(timeout);
  };

  // Function to handle submenu item click
  const handleSubItemClick = () => {
    setActiveSubMenu(null);
    setIsMenuOpen(false);
    setActiveMobileSubMenu(null);
    setActiveMobileNestedSubMenu(null);
  };

  // Function to open PDF
  const openPdf = (pdfUrl) => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    }
    handleSubItemClick();
  };

  // Clear timeout on component unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, [hideTimeout]);

  const navigate = useNavigate();

  return (
    <div className="bg-white min-h-1/2">
      {/* Top Contact Bar */}
      <div className="px-4 py-2 text-xs text-white bg-red-500 sm:text-sm">
        <div className="container flex flex-wrap items-center justify-between gap-2 mx-auto">
          <div className="flex flex-col items-start gap-1 md:items-center sm:flex-row sm:items-center sm:gap-2">
            <span className="hidden sm:inline">📍 {contactInfo.address}</span>
            <span>📞 {contactInfo.phone.join(" , ")}</span>
            <span>✉️ {contactInfo.email}</span>
          </div>
          <div className="relative flex items-center gap-2 text-xs sm:gap-4">
            {/* Gallery Menu */}
            <div className="relative group">
              <Link
                to={"/gallery/photos"}
                className="cursor-pointer hover:text-blue-500"
              >
                Gallery
              </Link>
            </div>

            {/* Other Links */}
            <Link to="/feedback/alumni" className="hover:text-blue-500">
              Alumni
            </Link>
            <Link
              to="https://www.google.com/maps?q=Government Women's Polytechnic College Sehore"
              className="hover:text-blue-500"
            >
              Site Map
            </Link>
          </div>
        </div>
      </div>

      {/* Header with Logo */}
      <header className="p-6 bg-yellow-200 md:py-4">
        <div className="container flex items-center justify-between px-4 py-6 mx-auto">
          <div className="flex items-center gap-8">
            <img
              src={logo}
              alt="College Logo"
              width={400}
              height={500}
              className="rounded-full"
            />
            <div className="hidden md:block">
              <h1 className="text-lg font-bold sm:text-2xl">
                Government Women's Polytechnic College, Sehore
              </h1>
              <p className="text-xs sm:text-sm">
                Affiliated to R.G.P.V. Bhopal, Approved by AICTE, New Delhi
              </p>
            </div>
          </div>
          <div className="items-center hidden gap-2 md:flex">
            <input
              type="search"
              placeholder="Search..."
              className="w-64 px-2 py-1 border border-gray-300 rounded"
            />
            <button className="p-2 bg-gray-200 rounded">
              <Search className="w-6 h-6" />
            </button>
          </div>
          <div className=" ml-5 px-2 py-1 border border-gray-300  bg-red-500 text-white items-center rounded transition-all duration-300 hover:text-red-500 hover:bg-blue-800">
            <button onClick={() => navigate("/login")}>Login</button>
          </div>

          <button
            className="p-2 md:hidden"
            onClick={() => setIsSearchOpen(!isSearchOpen)}
          >
            <Search className="w-5 h-5" />
          </button>
        </div>

        {isSearchOpen && (
          <div className="px-4 mt-2 md:hidden">
            <input
              type="search"
              placeholder="Search..."
              className="w-full px-2 py-1 border border-gray-300 rounded"
            />
          </div>
        )}

        <div>
          {/* Navigation */}
          <nav
            className="sticky top-0 z-50 text-white"
            style={{ backgroundColor: "#2A7B9B" }}
          >
            <div className="container relative flex justify-start mx-auto">
              {/* Mobile Navigation */}
              <div className="md:hidden">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="p-2 text-white"
                >
                  <Menu className="w-5 h-5" />
                </button>
                {isMenuOpen && (
                  <div className="absolute flex flex-col w-full font-bold text-white bg-blue-700 top-9">
                    {navItems.map((item) => (
                      <div key={item.title}>
                        <div>
                          <Link
                            to={item.link}
                            className="block px-3 py-1 transition-all duration-300 hover:text-red-500 hover:bg-blue-800"
                            onClick={() => {
                              if (item?.subItems) {
                                setActiveMobileSubMenu(
                                  activeMobileSubMenu === item.title
                                    ? null
                                    : item.title
                                );
                              } else {
                                setIsMenuOpen(false);
                              }
                            }}
                          >
                            {item.title}
                          </Link>
                        </div>

                        {/* Mobile submenu */}
                        {item.subItems &&
                          activeMobileSubMenu === item.title && (
                            <div className="pl-6">
                              {item.subItems.map((subItem) => (
                                <div key={subItem.title}>
                                  {subItem.subItems ? (
                                    <div>
                                      <div
                                        className="block px-3 py-1 transition-all duration-300 bg-blue-700 hover:text-red-500 hover:bg-blue-800 cursor-pointer"
                                        onClick={() => {
                                          setActiveMobileNestedSubMenu(
                                            activeMobileNestedSubMenu ===
                                              subItem.title
                                              ? null
                                              : subItem.title
                                          );
                                        }}
                                      >
                                        {"• " + subItem.title}
                                      </div>

                                      {activeMobileNestedSubMenu ===
                                        subItem.title && (
                                        <div className="pl-4">
                                          {subItem.subItems.map(
                                            (nestedItem) => (
                                              <div key={nestedItem.title}>
                                                {nestedItem.subItems ? (
                                                  <div>
                                                    <div className="block px-3 py-1 transition-all duration-300 bg-blue-600 hover:text-red-500 hover:bg-blue-700 cursor-pointer">
                                                      {"• " + nestedItem.title}
                                                    </div>
                                                    <div className="pl-4">
                                                      {nestedItem.subItems.map(
                                                        (deepNestedItem) => (
                                                          <Link
                                                            to={
                                                              deepNestedItem?.link
                                                            }
                                                          >
                                                            <div
                                                              key={
                                                                deepNestedItem.title
                                                              }
                                                              className="block px-3 py-1 transition-all duration-300 bg-blue-500 hover:text-red-500 hover:bg-blue-600 cursor-pointer"
                                                              // onClick={() =>
                                                              //   deepNestedItem.isPdf
                                                              //     ? openPdf(
                                                              //         deepNestedItem.link
                                                              //       )
                                                              //     : null
                                                              // }
                                                            >
                                                              {"• " +
                                                                deepNestedItem.title}
                                                            </div>
                                                          </Link>
                                                        )
                                                      )}
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <Link
                                                    to={nestedItem.link}
                                                    // onClick={handleSubItemClick}
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      openPdf(nestedItem.link);
                                                    }}
                                                    className="block px-3 py-1 transition-all duration-300 bg-blue-600 hover:text-red-500 hover:bg-blue-700"
                                                    target={
                                                      nestedItem.external
                                                        ? "_blank"
                                                        : "_self"
                                                    }
                                                  >
                                                    {"• " + nestedItem.title}
                                                  </Link>
                                                )}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <Link
                                      to={subItem.link}
                                      onClick={handleSubItemClick}
                                      className="block px-3 py-1 transition-all duration-300 bg-blue-700 hover:text-red-500 hover:bg-blue-800"
                                      target={
                                        subItem.external ? "_blank" : "_self"
                                      }
                                    >
                                      {"• " + subItem.title}
                                    </Link>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <ul className="items-center font-bold justify-center hidden gap-0 md:flex md:flex-wrap sm:gap-0 lg:gap-0 sm:flex-row sm:space-x-0 md:space-x-0">
                {navItems.map((item) => (
                  <li
                    key={item.title}
                    className="relative group"
                    onMouseEnter={() => handleMouseEnter(item.title)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to={item.link}
                      className="block px-3 py-2 text-sm transition-all duration-300 whitespace-nowrap hover:text-red-500 hover:bg-blue-700 group-hover:bg-blue-700"
                      onClick={() => item.link && handleSubItemClick()}
                    >
                      {item.title}
                    </Link>

                    {/* First-level Submenu */}
                    {item.subItems && (
                      <div className="absolute left-0 mt-[1px] w-48 h-auto rounded shadow-lg bg-blue-700 text-sm transition-all duration-300 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto z-10">
                        {item.subItems.map((subItem) => (
                          <div
                            key={subItem.title}
                            className="relative group/nested"
                          >
                            {subItem.subItems ? (
                              <>
                                <div className="block px-3 py-1 border-b border-gray-400 transition-all duration-300 hover:text-red-500 hover:bg-blue-800 hover:border-white cursor-pointer">
                                  {subItem.title}
                                </div>
                                {/* Second-level submenu */}
                                <div className="absolute left-full top-0 w-48 shadow-lg bg-blue-700 invisible opacity-0 transition-all duration-300 group-hover/nested:opacity-100 group-hover/nested:visible">
                                  {subItem.subItems.map((nestedItem) => (
                                    <div
                                      key={nestedItem.title}
                                      className="relative group/deep"
                                    >
                                      {nestedItem.subItems ? (
                                        <>
                                          <div className="block px-3 py-1 border-b border-gray-400 transition-all duration-300 hover:text-red-500 hover:bg-blue-800 hover:border-white cursor-pointer">
                                            {nestedItem.title}
                                          </div>
                                          {/* Third-level submenu */}
                                          <div className="absolute left-full top-0 w-48 shadow-lg bg-blue-700 invisible opacity-0 transition-all duration-300 group-hover/deep:opacity-100 group-hover/deep:visible">
                                            {nestedItem.subItems.map(
                                              (deepNestedItem) => (
                                                <div
                                                  key={deepNestedItem.title}
                                                  className="block px-3 py-1 border-b border-gray-400 last:border-b-0 transition-all duration-300 hover:text-red-500 hover:bg-blue-800 hover:border-white cursor-pointer"
                                                  onClick={() =>
                                                    deepNestedItem.isPdf
                                                      ? openPdf(
                                                          deepNestedItem.link
                                                        )
                                                      : null
                                                  }
                                                >
                                                  {deepNestedItem.title}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <Link
                                          to={nestedItem.link}
                                          // onClick={handleSubItemClick}
                                          className="block px-3 py-1 border-b border-gray-400 last:border-b-0 transition-all duration-300 hover:text-red-500 hover:bg-blue-800 hover:border-white"
                                          target={
                                            nestedItem.external
                                              ? "_blank"
                                              : "_self"
                                          }
                                          onClick={(e) => {
                                            e.preventDefault();
                                            openPdf(nestedItem.link);
                                          }}
                                        >
                                          {nestedItem.title}
                                        </Link>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </>
                            ) : (
                              <Link
                                to={subItem.link}
                                onClick={handleSubItemClick}
                                className="block px-3 py-1 border-b border-gray-400 last:border-b-0 transition-all duration-300 hover:text-red-500 hover:bg-blue-800 hover:border-white"
                                target={subItem.external ? "_blank" : "_self"}
                              >
                                {subItem.title}
                              </Link>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
}
